import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SeasonService } from '../shared/services/season/season.service';

@Injectable()
export class OnboardingResolveGuard {
  constructor(private seasonsService: SeasonService) {}

  resolve(
    /* eslint-disable @typescript-eslint/no-unused-vars */
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
    /* eslint-enable @typescript-eslint/no-unused-vars */
  ): Observable<any> | Promise<any> | any {
    const promises = [];

    if (!this.seasonsService.seasons || !this.seasonsService.seasons.length) {
      promises.push(this.seasonsService.getSeasons());
    }

    return Promise.all(promises);
  }
}
